




















































































import { defineComponent, ref, Ref, computed } from '@vue/composition-api'

// componnents
import { PageHeader } from '@/components'
import { Select2 } from '@/components/form'
import { DatePicker } from '@/components/general'
import moment from 'moment'
// const
import { APP_URL_API, optionsSemestre } from '@/constants'

// utils
import { dateLibs, getFullNameFormat } from '@/utils'

// hooks
import { useHeadquarter, useArea, useEmployeesOp } from '@/hooks'

export default defineComponent({
  name: 'ReportAsistance',
  components: {
    PageHeader,
    DatePicker,
    Select2
  },
  setup () {
    const URL_PDF = 'reports/cts'
    const title = ref('Reporte de CTS')
    const years = dateLibs.createRangeYears()
    const months = dateLibs.getAllMonths()
    const breadcrumbs = [
      {
        text: 'Dashboard',
        to: { name: 'home' }
      },
      {
        text: 'Reporte de CTS',
        active: true
      }
    ]
    const activeStatusOptions = [
      { value: 'active', text: 'Activos' },
      { value: 'inactive', text: 'Inactivos' }
    ]
    const year = ref(null)
    const date_init = ref(null)
    const semestre = ref(null)
    const date_end = ref(null)
    const monthi = ref(null)
    const monthf = ref(null)
    const headquarter = ref(null)
    const area: Ref<number|null> = ref(null)
    const subArea: Ref<number|null> = ref(null)
    const employeesIds: Ref<number[]> = ref([])
    const activeStatus: Ref<string|null> = ref(null)
    const { areasOptions, getAreasActive, loadingAreas, areas } = useArea()
    getAreasActive()

    const maxDateEnd = computed(() => {
      if (date_init.value) {
        console.log('holis')
        return moment(date_init.value).endOf('month').format('YYYY-MM-DD')
      }
      return null
    })

    const subareaOptions = computed(() => {
      const areaSelected = areas.value.find(a => Number(a.id) === Number(area.value))
      if (areaSelected) {
        return areaSelected.subAreas?.map(sub => {
          return {
            value: sub.id,
            text: sub.name
          }
        })
      }
      return []
    })

    const { employees, loadingEmployees } = useEmployeesOp()
    const employeesOp = computed(() => {
      return employees.value
        .filter(employee => !headquarter.value ? true : Number(employee.assignment.headquarter_id) === Number(headquarter.value))
        .filter(employee => !area.value ? true : Number(employee.assignment.area_id) === Number(area.value))
        .filter(employee => !subArea.value ? true : Number(employee.assignment.sub_area_id) === Number(subArea.value))
        .filter(employee => activeStatus.value === 'active' ? employee.is_active : !employee.is_active)
        .map(employee => {
          return {
            value: employee.id,
            text: getFullNameFormat(employee)
          }
        })
    })

    const printReport = () => {
      window.open(`${APP_URL_API}${URL_PDF}?year=${year.value}&semestre=${semestre.value}&employees=${employeesIds.value}&tipo=1`, '_blank')
    }

    const printReport2 = () => {
      window.open(`${APP_URL_API}${URL_PDF}?year=${year.value}&semestre=${semestre.value}&employees=${employeesIds.value}&tipo=2`, '_blank')
    }

    const addDaysToDate = (date: string) => {
      return dateLibs.addDaysToDate(date, 29)
    }

    const { headquartersSelectOptions, getHeadquatersActivated } = useHeadquarter()
    getHeadquatersActivated()

    return {
      title,
      breadcrumbs,
      years,
      months,
      year,
      monthi,
      monthf,
      date_init,
      semestre,
      date_end,
      moment,
      maxDateEnd,
      printReport,
      printReport2,
      addDaysToDate,
      headquarter,
      headquartersSelectOptions,
      areasOptions,
      loadingAreas,
      area,
      subArea,
      employeesIds,
      optionsSemestre,
      subareaOptions,
      employeesOp,
      loadingEmployees,
      activeStatus,
      activeStatusOptions
    }
  }
})
